module.exports = __webpack_public_path__ + "94c24543f7e3173cd76b36c289b7ca2a.svg";